import { Injectable } from '@angular/core';
import { AppConfig } from '../app.config';

export enum ApiVersion {
  v1 = 'v1',
  v2 = 'v2',
  v3 = 'v3'
}

@Injectable({
  providedIn: 'root'
})
export class UrlService {
  constructor() {
  }

  /**
   * Joins parts of a path, ensuring there are no duplicate or missing slashes.
   * @param parts Path segments to join.
   * @returns The resolved path.
   */
  private resolvePath(...parts: string[]): string {
    return parts
      .map((part) => part.replace(/(^\/|\/$)/g, '')) // Remove leading and trailing slashes
      .filter((part) => part.length > 0) // Filter out empty segments
      .join('/'); // Join with a single slash
  }

  /**
   * Joins parts of a path, ensuring there are no duplicate or missing slashes.
   * @param baseUrl Base url.
   * @param parts Path segments to join.
   * @returns The resolved path.
   */
  resolveHref(baseUrl: string, ...parts: string[]): string {
    return `${baseUrl}/${this.resolvePath(...parts)}`;
  }

  /**
   * Gets the Base URL, handling the root path.
   * @returns The Base URL.
   */
  getApiBaseUrl(): string {
    return AppConfig.settings.apiServer.baseUrl;
  }

  /**
   * Gets the Base URL, handling the root path.
   * @returns The Base URL.
   */
  getDashboardBaseUrl(): string {
    return `${window.location.protocol}//${window.location.host}`;
  }

  /**
   * Gets the full API URL, resolving paths.
   * @param version The api version to use.
   * @param parts The additional path parts to append to the API base path.
   * @returns The resolved API URL.
   */
  getApiUrl(version: ApiVersion, ...parts: string[]): string {
    return this.resolveHref(this.getApiBaseUrl(), AppConfig.settings.paths.api, version, ...parts);
  }

  /**
   * Gets the full Dashboard URL, resolving paths.
   * @param parts The additional path parts to append to the Dashboard base path.
   * @returns The resolved Dashboard URL.
   */
  getDashboardUrl(...parts: string[]): string {
    return this.resolveHref(this.getDashboardBaseUrl(), AppConfig.settings.paths.dashboard, ...parts);
  }
}
